import { useFetch } from "../useFetch";
import type {
	CreateMethodPayload,
	MethodResponse,
	UpdateMethodPayload,
} from "../../core/types/control/";

export function useMethods() {
	return useFetch<MethodResponse[]>({
		endpoint: "/methods",
		method: "GET",
	});
}

export function useMethod(id: number) {
	return useFetch<MethodResponse>({
		endpoint: `/methods/${id}`,
		method: "GET",
	});
}

export function useCreateMethod() {
	const fetch = useFetch<MethodResponse, CreateMethodPayload>({
		endpoint: "/methods",
		method: "POST",
		auto: false,
	});

	const create = (data: CreateMethodPayload) => {
		return fetch.execute({ body: data });
	};

	return { ...fetch, create };
}

export function useUpdateMethod(id: number) {
	const fetch = useFetch<MethodResponse, UpdateMethodPayload>({
		endpoint: `/methods/${id}`,
		method: "PATCH",
		auto: false,
	});

	const update = (data: UpdateMethodPayload) => {
		return fetch.execute({ body: data });
	};

	return { ...fetch, update };
}

export function useUpdateMethodStatus() {
	const fetch = useFetch<MethodResponse, { is_active: boolean }>({
		endpoint: "/methods",
		method: "PATCH",
		auto: false,
	});

	const updateStatus = (id: number, isActive: boolean) => {
		return fetch.execute({
			endpoint: `/methods/${id}/status`,
			body: { is_active: isActive },
		});
	};

	return { ...fetch, updateStatus };
}
